import store from '@/store/index.js';
import logger from './logger';
import config from 'libs/config.js';
import utils from 'libs/utils';

export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue) {
    // ES6 way of const job = options.job
    // Add $plugin instance method directly to Vue components
    Vue.prototype.$authorize = async (keys) => {
      let tovalidate = keys;
      if (keys.constructor !== Array) {
        tovalidate = [keys];
      }
      if (config.isDebug) {
        logger.log('validate', tovalidate);
      }
      let res = false;
      await store.dispatch('security/authorize', tovalidate).then(isAuthorized => {
        res = isAuthorized;
        logger.log(isAuthorized, 'is authorized');
        if (!isAuthorized) {
          console.warn('not authorized from plugin');
        }
        if (config.isDebug) {
          // always authorized when in debug mode
          res = true;
        }
      }).catch(err => console.error(err));

      return res;
    };
    let cookie = utils.getCookie('SessionLifetime');
    if (cookie) {
      let minutes = parseFloat(utils.getCookie('SessionLifetime').replace(',', '.'));
      if (minutes) {
        SessionSettings.SessionTimeout = minutes;
        SessionSettings.Refresh();
        getSessionLifeTime();
      }
    }
  }
};

const setNextCheckSessionStorage = (timeInMs) => {
  window.sessionStorage.setItem('next-check', new Date(new Date().getTime() + timeInMs));
};

const getSessionLifeTime = () => {
  console.debug('starting session checks');
  let now = new Date();

  const ls = window.localStorage;
  let expiresAt = ls.getItem('expires');
  if (expiresAt) {
    logger.log('expires at = ', expiresAt);
    let ms = new Date(expiresAt) - now + 10000;
    let minutes = ms / 60000;
    
    setTimeout(() => checkExpiredSession(), ms);
    setNextCheckSessionStorage(ms);

    logger.log(`Checking in: ${minutes}min (${ms} ms)`);
  }
};


const checkExpiredSession = () => {
  const ls = window.localStorage;
  let lastExpiration = ls.getItem('expires');
  let now = new Date();

  if (lastExpiration) {
    let expInMs = (new Date(lastExpiration) - now);
    logger.log('expInMs', expInMs);

    let expired = ((new Date(lastExpiration) - now) < 0);
    
    if (!expired) {
      // determine next check (10s after expiration)
      let expiresIn = (new Date(lastExpiration) - now) + 10000;
      if (expiresIn > 0) {
        setTimeout(() => checkExpiredSession(), expiresIn);
        setNextCheckSessionStorage(expiresIn);
        logger.log(`Not expired, Checking again in ${expiresIn/1000}s`);
        return;
      }
    }
  }

  logger.log('logged out, lastExpiration null:', lastExpiration === null);
  utils.RedirectToLogin();
};


export class SessionSettings {
  static timeout = null;
  static warnFunc = null;
  static redirectFunc = null;

  static set SessionTimeout (value) {
    SessionSettings.timeout = value;
    logger.log(`Session lifetime set ${value} minutes.`);
  }
  static get SessionTimeout () {
    return SessionSettings.timeout;
  }
  static get SessionTimeoutMs () {
    return SessionSettings.timeout * 60000 + 30000;
  }

  static Refresh () {
    const ls = window.localStorage;
    if (window.loggedIn === undefined) {
      return;
    }

    if (window.loggedIn.toLowerCase() === 'true') {
      let newDateObj = new Date(new Date().getTime() + (SessionSettings.timeout * 60000) + 5000);
      ls.setItem('expires', newDateObj);
      logger.log('Expired date set at: ', ls.getItem('expires'));
    } else if (window.loggedIn.toLowerCase() === 'false') {
      ls.removeItem('expires');
    } 
  }
}

